<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">PREFACE</p>
<p class="noindent">I always knew that I wanted to author a book using my research skills, but I just didn’t know when the right story would hit me. I was working on a different story for a freelance column I write for a local newspaper when I stumbled upon a January 7, 1985 article in the <i>Palm Beach Post</i> that listed several Palm Beach County–area unsolved murders from 1984. That year is considered one of the “bloodiest on record” in our local history, with 113 homicides by the year’s end. After the year’s end, 16 remained unsolved. The very first one at the top of the list jumped right out at me:</p>
<p class="ext1"><i>Jeffrey Heagerty, 19, was found floating in a Royal Palm Beach canal at 10 a.m. on July 1. He had been to several bars June 30 and was last seen at Kevin’s Lounge</i> [Cabaret] <i>in West Palm Beach in the early morning hours of July 1. He had been strangled and his car was missing.</i></p>
<p class="indent1">From that paragraph alone, I knew this would make for an interesting story, perhaps another newspaper article for me to write, but I <i>never</i> imagined all the twist and turns I’d find that were yet to happen in the years following when that snippet was published in the <i>Post.</i></p>
<p class="indent">Everything in this story is based on police records, court records, newspaper stories and memories of those associated with the incident. This was thirty-four years ago, so I do caution that some things may not necessarily be the way others remember it. At times, this was difficult to research since police, court records and newspapers often misspelled “Jeffrey” as “Jeffery.”</p>
<p class="indent">Furthermore, in talking to Jeff ’s friends and family, as well as reading <i>every</i> page of the court transcripts, I determined that how the events played out leading up to Jeff ’s murder may have varied slightly compared to how the media sensationalized them. Bear that in mind when reading the story.</p>
<div class="image-break">
<p class="image"><img alt="Images" src="images/14-1.jpg"/></p>
</div>
<div class="image-break">
<p class="image"><img alt="Images" src="images/15-1.jpg"/></p>
<p class="caption">The year 1984 was one of Palm Beach County’s deadliest on record. The <i>Palm Beach Post</i> published a list of every homicide up to September of that year. Of the 116 homicides in Palm Beach County that year, 16 were still unsolved by January 1, 1985. Jeff ’s was one of them. <i>Courtesy the</i> Palm Beach Post.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Preface.vue?8c553248